import { render, staticRenderFns } from "./CookingInstructionModal.vue?vue&type=template&id=bcfca8dc&scoped=true"
import script from "./CookingInstructionModal.vue?vue&type=script&lang=js"
export * from "./CookingInstructionModal.vue?vue&type=script&lang=js"
import style0 from "./CookingInstructionModal.vue?vue&type=style&index=0&id=bcfca8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfca8dc",
  null
  
)

export default component.exports